module.exports = __webpack_public_path__ + "public/Icons/lightModeOn.svg?9caf4dc4";